import { SERVICE } from '@src/api/types/shared/serviceType';
import CommonHelmet from '@src/components/CommonHelmet';
import CompanyGuard from '@src/components/guard/CompanyGuard';
import SupportServicesList from '@src/features/company/support-services/SupportServicesList';
import CompanyDefaultLayout from '@src/layouts/company/CompanyDefaultLayout';

function CompanySupportServicesList() {
  return (
    <CompanyGuard canService={[SERVICE.ENTERPRISE_PORTAL, SERVICE.DX_DIAGNOSIS]}>
      <CompanyDefaultLayout pageName='support-services'>
        <CommonHelmet />
        <SupportServicesList />
      </CompanyDefaultLayout>
    </CompanyGuard>
  );
}

export default CompanySupportServicesList;
